import { render, staticRenderFns } from "./MailAll.vue?vue&type=template&id=8a87cdf4&scoped=true&"
import script from "./MailAll.vue?vue&type=script&lang=js&"
export * from "./MailAll.vue?vue&type=script&lang=js&"
import style0 from "./MailAll.vue?vue&type=style&index=0&id=8a87cdf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a87cdf4",
  null
  
)

export default component.exports